import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { StaticDashboard2StoredData } from '../types';

type StaticDashboardTables = StaticDashboard2StoredData['tables'];

type GetChartDataParams = {
  queryKey?: string[];
  chartId?: string;
};

const useGetStaticDashboardChartData = (tables?: StaticDashboardTables) => {
  const queryClient = useQueryClient();

  const getChartData = useCallback(
    ({ queryKey, chartId }: GetChartDataParams) => {
      const queryData = queryKey
        ? queryClient.getQueryData<ChartTableRes>(queryKey)
        : undefined;

      if (queryData) return queryData;

      if (chartId) {
        return tables?.find((table) => table.alias === chartId)?.table;
      }

      return undefined;
    },
    [queryClient, tables],
  );

  return { getChartData };
};

export { useGetStaticDashboardChartData };
